// Fonts

import "@fontsource/montserrat";
import "@fontsource/ubuntu";

export const fonts = {
  heading: "Ubuntu",
  body: "Ubuntu"
};
